import React, { createContext, useContext, useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import api from '../api';
import AuthShell from './AuthShell';
import Spinner from '../components/Spinner';

const defaults = { template: 'standard', oauth: false, query: '' };
const Context = createContext(defaults);
export const useAuthContext = () => useContext(Context);

export function authHref(to, query) {
    if (!query || !to.startsWith('/') || to.startsWith('/dashboard')) return to;
    return to + (to.includes('?') ? '&' : '?') + query;
}
export const AuthLink = ({ to, ...props }) => {
    const context = useAuthContext();
    return <Link to={authHref(to, context.query)} {...props} />;
};

export default function AuthContextProvider() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const flow = params.get('flow');
    const appearance = params.get('appearance');
    const state = location.pathname === '/consent' ? params.get('state') : null;
    const key = `${flow || ''}|${appearance || ''}|${state || ''}`;
    const [resolved, setResolved] = useState(null);
    useEffect(() => {
        let active = true;
        const query = new URLSearchParams();
        if (flow) query.set('flow', flow);
        else if (appearance) query.set('appearance', appearance);
        const finish = value => { if (active) setResolved({ key, ...defaults, ...value, query: query.toString() }); };
        if (state) api.get('/api/consent', { params: { state } }).then(res => finish({ template: res.data.template || 'standard', oauth: true })).catch(() => finish({ error: 'Запрос авторизации недействителен. Начните вход из сервиса заново.' }));
        else if (flow || appearance) api.get('/api/auth/context', { params: { flow, appearance } }).then(res => finish(res.data)).catch(() => finish({ error: 'Запрос входа устарел. Начните вход из сервиса заново.' }));
        else finish(defaults);
        return () => { active = false; };
    }, [key, flow, appearance, state]);
    const context = resolved?.key === key ? resolved : null;
    useEffect(() => {
        const template = context?.template;
        const favicon = document.querySelector('link[rel="icon"][type="image/svg+xml"]');
        document.title = template === 'burgerbot' ? 'BurgerBot — Вход' : 'IT-Burger — Аккаунт';
        if (favicon) favicon.href = `${process.env.PUBLIC_URL}/${template === 'burgerbot' ? 'branding/burgerbot-logo.svg' : 'logo_circled.svg'}`;
        return () => {
            document.title = 'IT-Burger — Аккаунт';
            if (favicon) favicon.href = `${process.env.PUBLIC_URL}/logo_circled.svg`;
        };
    }, [context?.template]);
    if (!context) return <div className="auth-loading"><Spinner size={28} /><span>Загрузка…</span></div>;
    return <Context.Provider value={context}>{context.error ? <AuthShell title="Вход прерван"><p role="alert">{context.error}</p><Link to="/login" className="auth-reset-link">Войти в кабинет IT-Burger</Link></AuthShell> : <Outlet />}</Context.Provider>;
}
